import React from 'react'
import CvView from './CvView';

export default function MainCvthequeView(props) { 
    return (  
        <CvView  {...props}/>              
    )
}
